import React from "react";
import heroImage from "./Assets/newimage.png";
import organiseThoughts from "./Assets/organiseThoughts.png";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import { ReactSVG } from "react-svg";
import { useInView } from "react-intersection-observer";
import { useDownload } from "./DownloadContext";

const HeroSection = () => {
  const { startDownload } = useDownload();
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: textRef, inView: textView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: btnRef, inView: btnView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });
  const { ref: visualRef, inView: visualView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  return (
    <div className="relative overflow-hidden rounded-2xl mt-6 md:mt-0 border border-[#3AB1F626]">
      <div className="absolute top-0 left-0 w-full h-full flex flex-col z-0">
        <div className="relative flex-[1] bg-gradient-to-t from-[#3AB1F650] to-[#D8EFFD] rounded-2xl">
          <svg
            className="absolute top-0 left-0 w-full h-full rounded-2xl z-[4]"
            viewBox="0 0 1000 1350"
            preserveAspectRatio="none"
          >
            <path
              id="dfwOrbitPath"
              d="M40,0 H960 A40,40 0 0 1 1000,40 V1310 A40,40 0 0 1 960,1350 H40 A40,40 0 0 1 0,1310 V40 A40,40 0 0 1 40,0 Z"
              fill="none"
              stroke="transparent"
            />
            <circle r="300" fill="url(#dfwGlow)" filter="url(#dfwBlur)">
              <animateMotion
                repeatCount="indefinite"
                dur="20s"
                rotate="auto"
              >
                <mpath href="#dfwOrbitPath" />
              </animateMotion>
            </circle>
            <circle r="300" fill="url(#dfwGlow)" filter="url(#dfwBlur)">
              <animateMotion
                repeatCount="indefinite"
                dur="20s"
                rotate="auto"
                keyPoints="1;0"
                keyTimes="0;1"
              >
                <mpath href="#dfwOrbitPath" />
              </animateMotion>
            </circle>
            <defs>
              <radialGradient id="dfwGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#3AB1F6" stopOpacity=".9" />
                <stop offset="100%" stopColor="#3AB1F6" stopOpacity="0" />
              </radialGradient>
            </defs>
            <filter
              id="dfwBlur"
              x="-100%"
              y="-100%"
              width="300%"
              height="300%"
            >
              <feGaussianBlur in="SourceGraphic" stdDeviation="20" />
            </filter>
          </svg>
        </div>
      </div>

      <div className="relative z-10 flex md:flex-row flex-col items-center md:gap-16 lg:gap-20 gap-24 md:pt-60 pt-48 md:pb-52 pb-32 lg:px-16 md:px-8 px-4">
        <div className="flex-1 flex flex-col md:items-start items-center gap-5">
          <h1
            ref={headingRef}
            style={{ animationDelay: "0ms" }}
            className={`${headingView ? "animate-slideRight z-[3] anim-preserve" : "opacity-0 z-0"
              } font-jakarta font-extrabold text-[#0F1B2D] text-center md:text-left text-[2.625rem] md:text-[2.4rem] lg:text-[2.8rem] xl:text-[3.125rem] leading-[1.1] tracking-[-0.025em]`}
          >
            The Fastest Way to{" "}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#3AB1F6] to-[#407BFF]">
              Write on Windows.
            </span>
          </h1>

          <p
            ref={textRef}
            style={{ animationDelay: "150ms" }}
            className={`${textView ? "animate-slideRight z-[3] anim-preserve" : "opacity-0 z-0"
              } font-inter font-normal text-[#33425A] text-center md:text-left text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] lg:text-[1.3125rem] leading-[1.5] max-w-[641px]`}
          >
            Zero Typing turns your voice into clean, ready-to-use text across
            emails, documents, messages, and work apps. No fixing.
          </p>

          <div
            ref={btnRef}
            style={{ animationDelay: "300ms" }}
            className={`${btnView ? "animate-scaleIn z-[3] anim-preserve" : "opacity-0 z-0"
              } flex sm:flex-row flex-col items-center gap-3 mt-2`}
          >
            <button
              type="button"
              onClick={() => startDownload()}
              style={{
                background: "linear-gradient(90deg, #3AB1F6 0%, #407BFF 100%)",
              }}
              className="hover:opacity-90 transition-opacity duration-300 text-white rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base shadow-md"
            >
              <ReactSVG
                src={microsoftIcon}
                beforeInjection={(svg) => {
                  svg.setAttribute("class", "w-5 h-5");
                }}
              />
              Download for Windows
            </button>

            {/* <button className="bg-white border border-[#0000001A] hover:bg-gray-50 transition rounded-full flex items-center gap-2 px-6 py-3 font-inter font-semibold text-base text-[#0F1B2D]">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
              Watch 45-sec demo
            </button> */}
          </div>
        </div>

        <div
          ref={visualRef}
          className={`${visualView ? "animate-slideLeft z-[3] anim-preserve" : "opacity-0 z-0"
            } flex-1 w-full flex justify-center`}
        >
          <div className="relative w-full max-w-[520px] md:max-w-[560px] lg:max-w-[600px] leading-none self-center">
            <img
              src={heroImage}
              alt="Zero Typing on Windows"
              className="block w-full h-auto"
            />
            <img
              src={organiseThoughts}
              alt="Organise Thoughts"
              className="absolute z-20 left-1/2 -translate-x-1/2 top-0 -translate-y-[110%] w-[42%] sm:w-[36%] md:w-[34%] lg:w-[34%] h-auto pointer-events-none drop-shadow-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
